module.exports = __webpack_public_path__ + "a9e202d02e95856b2394e37008d62982.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/AccessPlace - Search - Selected - Desktop 2.png
// module id = 1041
// module chunks = 0